'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var log = require('debug')('ipfs:mfs:utils:update-tree');

var addLink = require('./add-link');

var defaultOptions = {
  shardSplitThreshold: 1000
}; // loop backwards through the trail, replacing links of all components to update CIDs

var updateTree = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, trail, options) {
    var index, child, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, node, cid, name, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = Object.assign({}, defaultOptions, options);
            log('Trail', trail);
            trail = trail.slice().reverse();
            index = 0;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 6;
            _iterator = _asyncIterator(context.ipld.getMany(trail.map(function (node) {
              return node.cid;
            })));

          case 8:
            _context.next = 10;
            return _iterator.next();

          case 10:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 14;
            return _step.value;

          case 14:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 30;
              break;
            }

            node = _value;
            cid = trail[index].cid;
            name = trail[index].name;
            index++;

            if (child) {
              _context.next = 23;
              break;
            }

            child = {
              cid: cid,
              name: name,
              size: node.size
            };
            return _context.abrupt("continue", 27);

          case 23:
            _context.next = 25;
            return addLink(context, {
              parent: node,
              name: child.name,
              cid: child.cid,
              size: child.size,
              flush: options.flush,
              shardSplitThreshold: options.shardSplitThreshold,
              hashAlg: options.hashAlg,
              cidVersion: options.cidVersion
            });

          case 25:
            result = _context.sent;
            // new child for next loop
            child = {
              cid: result.cid,
              name: name,
              size: result.size
            };

          case 27:
            _iteratorNormalCompletion = true;
            _context.next = 8;
            break;

          case 30:
            _context.next = 36;
            break;

          case 32:
            _context.prev = 32;
            _context.t0 = _context["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 36:
            _context.prev = 36;
            _context.prev = 37;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 41;
              break;
            }

            _context.next = 41;
            return _iterator.return();

          case 41:
            _context.prev = 41;

            if (!_didIteratorError) {
              _context.next = 44;
              break;
            }

            throw _iteratorError;

          case 44:
            return _context.finish(41);

          case 45:
            return _context.finish(36);

          case 46:
            log("Final CID ".concat(child.cid));
            return _context.abrupt("return", child.cid);

          case 48:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 32, 36, 46], [37,, 41, 45]]);
  }));

  return function updateTree(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = updateTree;